import { productFromFirestore, ProductStatus } from '@parallel-fluidics/shared/models/products';
import {
  collection,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { useCallback, useEffect, useState } from 'react';

/**
 * Searches active products by SKU prefix. Returns a stable `search` function
 * and the current result list.
 *
 * @param {string} filterText - SKU substring to search for
 */
export default function useSearchProducts(filterText = '') {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchProducts = useCallback(async (text) => {
    setIsLoading(true);
    try {
      const db = getFirestore();
      const normalized = text.trim().toUpperCase();
      const baseRef = collection(db, 'products');

      let q;
      if (normalized) {
        q = query(
          baseRef,
          where('status', '==', ProductStatus.ACTIVE),
          orderBy('sku', 'asc'),
          where('sku', '>=', normalized),
          where('sku', '<=', `${normalized}\uf8ff`),
          limit(20),
        );
      } else {
        q = query(
          baseRef,
          where('status', '==', ProductStatus.ACTIVE),
          orderBy('updatedAt', 'desc'),
          limit(20),
        );
      }

      const snapshot = await getDocs(q);
      setProducts(snapshot.docs.map(productFromFirestore));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('useSearchProducts error:', err);
      setProducts([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProducts(filterText);
  }, [filterText, fetchProducts]);

  return { products, isLoading, refetch: fetchProducts };
}
